/* V2 kit: explicit gifts use the metadata verified on the working source cart. */
(function(){
  var busy=false;
  function go(btn){
    if(busy)return;
    busy=true;
    var original=btn.textContent;
    var line={id:btn.getAttribute('data-variant-id'),quantity:1,selling_plan:btn.getAttribute('data-selling-plan')};
    var gifts=[42452307345594,41614590345402,43193943130298].map(function(id){return {id:id,quantity:1,properties:{_Gifted:'clc-tse-atf-01 30-day'}};});
    btn.textContent='Loading...';
    fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[line].concat(gifts)})})
      .then(function(r){if(!r.ok)throw new Error('Cart addition failed');return r.json();})
      .then(function(){window.location.assign('/checkout');})
      .catch(function(){busy=false;btn.textContent=original;var msg=document.getElementById('v2-cart-error');if(!msg){msg=document.createElement('p');msg.id='v2-cart-error';msg.setAttribute('role','alert');btn.insertAdjacentElement('afterend',msg);}msg.textContent='Your kit could not be added. Please try again.';});
  }
  document.addEventListener('click',function(e){var btn=e.target.closest&&e.target.closest('#m-atc,#d-atc');if(!btn)return;e.preventDefault();go(btn);});
})();
